import 'src/libs/unhandledErrors';
import '@gravity-ui/uikit/styles/fonts.css';
import '@gravity-ui/uikit/styles/styles.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'antd/dist/reset.css';
import './overrides.css';
import './app.scss';

import { ThemeProvider, ToasterComponent, ToasterProvider } from '@gravity-ui/uikit';
import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Loading from 'skd-ui/Loading/Loading';
import Alerts from 'src/components/Alerts/Alerts';
import CheckFrontendVersion from 'src/components/core/CheckFrontendVersion/CheckFrontendVersion';
import CheckTranslatePage from 'src/components/core/CheckTranslatePage/CheckTranslatePage';
import InternetConnectionStatus from 'src/components/core/InternetConnectionStatus/InternetConnectionStatus';
import Toolbar from 'src/components/Toolbar/Toolbar';
import { FrontendUrls } from 'src/constants/url';
import Accounting from 'src/controllers/Accounting/Accounting.loadable';
import CreateMassOperations from 'src/controllers/Accounting/createOperations/CreateMassOperationsController.loadable';
import Api from 'src/controllers/Api/Api.loadable';
import Help from 'src/controllers/Help/Help.loadable';
import Home from 'src/controllers/Home/Home.loadable';
import LogIn from 'src/controllers/LogIn/LogIn.loadable';
import Map from 'src/controllers/Map/Map.loadable';
import NotFind from 'src/controllers/NotFind/NotFind';
import Order from 'src/controllers/Order/Order.loadable';
import Orders from 'src/controllers/Orders/Orders.loadable';
import SignUp from 'src/controllers/SignUp/SignUp.loadable';
import User from 'src/controllers/User/User.loadable';
import Users from 'src/controllers/Users/Users.loadable';
import { issueSessionByToken } from 'src/dataProviders/users';
import store from 'src/reduxStore/reducers';
import { fetchPresets } from 'src/stores/fetchPresets';
import FrontendVersionStore from 'src/stores/FrontendVersion';
import { toaster } from 'src/stores/Toaster';
import UsersStore from 'src/stores/Users';

// todo: move

// @ts-ignore
// to fix TypeError: Do not know how to serialize a BigInt
// eslint-disable-next-line no-extend-native
BigInt.prototype.toJSON = function () {
	return this.toString();
};

const mount = document.getElementById('mount');
const alerts = document.getElementById('alerts');
const internetConnectionStatus = document.getElementById('internetConnectionStatus');
const checkTranslatePage = document.getElementById('checkTranslatePage');
const checkFrontendVersion = document.getElementById('checkFrontendVersion');

const mountRoot = createRoot(mount);
const alertsRoot = createRoot(alerts);
const internetConnectionStatusRoot = createRoot(internetConnectionStatus);
const checkTranslatePageRoot = createRoot(checkTranslatePage);
const checkFrontendVersionRoot = createRoot(checkFrontendVersion);

function AppWithCallbackAfterRender() {
	const [isLoaded, setIsLoaded] = useState(false);
	useEffect(() => {
		async function fetchData() {
			try {
				const url = new URL(document.location.toString());
				const interimToken = url.searchParams.get('interimToken');
				if (interimToken) {
					await issueSessionByToken({ token: interimToken });
				}
				await UsersStore.getCurrentUser();
				void fetchPresets();
			} finally {
				setIsLoaded(true);
			}
		}

		fetchData();
	}, []);

	useEffect(() => {
		function makePeriodRequests() {
			UsersStore.getCurrentUser();
			// нет смысла запрашивать на старте приложения - там мы бы получили сразу новую версию, только со временем работы она может просрочиться
			FrontendVersionStore.fetchVersion();
		}

		let lastTimeTabVisible = Date.now();
		function onVisibilityChange() {
			if (document.hidden) {
				return;
			}
			if (Date.now() - lastTimeTabVisible > 1000 * 60 * 5) {
				makePeriodRequests();
			}
			lastTimeTabVisible = Date.now();
		}

		const timer = setInterval(() => makePeriodRequests, 1000 * 60 * 10);
		document.addEventListener('visibilitychange', onVisibilityChange);

		return () => {
			clearInterval(timer);
			document.removeEventListener('visibilitychange', onVisibilityChange);
		};
	}, []);

	if (isLoaded) {
		return (
			<Provider store={store}>
				<ThemeProvider theme="light">
					<ToasterProvider toaster={toaster}>
						<Router>
							<Toolbar />
							<Routes>
								<Route path={FrontendUrls.Home}>
									<Route index element={<Home />} />
									<Route path={FrontendUrls.Api} element={<Api />} />
									<Route path={FrontendUrls.LogIn} element={<LogIn />} />
									<Route path={FrontendUrls.SignUp} element={<SignUp />} />
									<Route path={FrontendUrls.Users} element={<Users />} />
									<Route path={FrontendUrls.User} element={<User />} />
									<Route path={FrontendUrls.Orders} element={<Orders />} />
									<Route path={FrontendUrls.Order} element={<Order />} />
									<Route path={FrontendUrls.Accounting} element={<Accounting />} />
									<Route path={FrontendUrls.AccountingLink} element={<Accounting />} />
									<Route path={FrontendUrls.AccountingMassCreate} element={<CreateMassOperations />} />
									<Route path={FrontendUrls.Help} element={<Help />} />
									<Route path={FrontendUrls.Map} element={<Map />} />
									<Route path={FrontendUrls.NotFind} element={<NotFind />} />
								</Route>
							</Routes>
						</Router>
						<ToasterComponent />
					</ToasterProvider>
				</ThemeProvider>
			</Provider>
		);
	}

	return <Loading />;
}

mountRoot.render(<AppWithCallbackAfterRender />);
alertsRoot.render(
	<Provider store={store}>
		<Alerts />
	</Provider>,
);
internetConnectionStatusRoot.render(<InternetConnectionStatus />);
checkTranslatePageRoot.render(<CheckTranslatePage />);
checkFrontendVersionRoot.render(<CheckFrontendVersion />);
